import { Link } from "react-router-dom";
import { Grid } from '@mui/material';
import './Tags.css';

const Tags = () => {
    return (
          <div className="TicketingTagsContainer">
            <div className="main"><h1>Tags</h1></div>;
          </div>
    );
  };
  
  export default Tags;